import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';
import { FIREBASE_CONFIG } from '../constants/firebase';

// Initialize Firebase (singleton)
let app: FirebaseApp;

const getFirebaseApp = (): FirebaseApp => {
  if (!app)
    app = getApps().length === 0 ? initializeApp(FIREBASE_CONFIG) : getApps()[0];

  return app;
};

// Get messaging instance (only in browser)
export const getMessagingInstance = (): Messaging | null => {
  if (typeof window !== 'undefined' && 'Notification' in window) {
    try {
      return getMessaging(getFirebaseApp());
    } catch {
      return null;
    }
  }
  return null;
};

export { getToken, onMessage, getFirebaseApp };
